export const teethGapConfig = {
    topLeft: {
        maxX: 590,
        maxY: 80,
        minX: 50,
        minY: 20,
        values: [
            {
                value: 0,
                positionX: 129,
                positionY: 50,
                boundX: 130,
            },
            {
                value: 1,
                positionX: 210,
                positionY: 50,
                boundX: 210,
            },
            {
                value: 2,
                positionX: 295,
                positionY: 50,
                boundX: 300,
            },
            {
                value: 3,
                positionX: 365,
                positionY: 50,
                boundX: 365,
            },
            {
                value: 4,
                positionX: 430,
                positionY: 50,
                boundX: 430,
            },
            {
                value: 5,
                positionX: 482,
                positionY: 50,
                boundX: 482,
            },
            {
                value: 6,
                positionX: 540,
                positionY: 50,
                boundX: 540,
            },
            {
                value: 7,
                positionX: 590,
                positionY: 50,
                boundX: 590,
            },
        ],
    },
    topRight: {
        maxX: 1130,
        maxY: 80,
        minX: 590,
        minY: 20,
        values: [
            {
                value: 8,
                positionX: 645,
                positionY: 50,
                boundX: 650,
            },
            {
                value: 9,
                positionX: 700,
                positionY: 50,
                boundX: 700,
            },
            {
                value: 10,
                positionX: 750,
                positionY: 50,
                boundX: 750,
            },
            {
                value: 11,
                positionX: 820,
                positionY: 50,
                boundX: 820,
            },
            {
                value: 12,
                positionX: 885,
                positionY: 50,
                boundX: 885,
            },
            {
                value: 13,
                positionX: 970,
                positionY: 50,
                boundX: 970,
            },
            {
                value: 14,
                positionX: 1050,
                positionY: 50,
                boundX: 1050,
            },
            // {
            //   value: 15,
            //   positionX: 1130,
            //   positionY: 50,
            //   boundX: 1130
            // }
        ],
    },
    bottomLeft: {
        maxX: 590,
        maxY: 250,
        minX: 50,
        minY: 180,
        values: [
            {
                value: 16,
                positionX: 130,
                positionY: 200,
                boundX: 130,
            },
            {
                value: 17,
                positionX: 210,
                positionY: 200,
                boundX: 210,
            },
            {
                value: 18,
                positionX: 300,
                positionY: 200,
                boundX: 300,
            },
            {
                value: 19,
                positionX: 365,
                positionY: 200,
                boundX: 365,
            },
            {
                value: 20,
                positionX: 430,
                positionY: 200,
                boundX: 430,
            },
            {
                value: 21,
                positionX: 482,
                positionY: 200,
                boundX: 482,
            },
            {
                value: 22,
                positionX: 540,
                positionY: 200,
                boundX: 540,
            },
            {
                value: 23,
                positionX: 590,
                positionY: 200,
                boundX: 590,
            },
        ],
    },
    bottomRight: {
        maxX: 1130,
        maxY: 250,
        minX: 590,
        minY: 180,
        values: [
            {
                value: 24,
                positionX: 645,
                positionY: 200,
                boundX: 650,
            },
            {
                value: 25,
                positionX: 700,
                positionY: 200,
                boundX: 700,
            },
            {
                value: 26,
                positionX: 750,
                positionY: 200,
                boundX: 750,
            },
            {
                value: 27,
                positionX: 820,
                positionY: 200,
                boundX: 820,
            },
            {
                value: 28,
                positionX: 885,
                positionY: 200,
                boundX: 885,
            },
            {
                value: 29,
                positionX: 970,
                positionY: 200,
                boundX: 970,
            },
            {
                value: 30,
                positionX: 1050,
                positionY: 200,
                boundX: 1050,
            },
            // {
            //   value: 31,
            //   positionX: 1130,
            //   positionY: 200,
            //   boundX: 1130
            // }
        ],
    },
};
